import React from 'react';
import { FaLeaf } from 'react-icons/fa';

const AppIcon = ({ size = 40, backgroundColor = '#000', iconColor = '#28a745', className = '' }) => {
  const iconStyle = {
    width: size,
    height: size,
    backgroundColor: backgroundColor,
    borderRadius: size * 0.3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  };

  return (
    <div className={`app-icon ${className}`} style={iconStyle}>
      <FaLeaf size={size * 0.6} color={iconColor} />
    </div>
  );
};

export default AppIcon;
